import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=52b42edf&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=52b42edf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b42edf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b42edf')) {
      api.createRecord('52b42edf', component.options)
    } else {
      api.reload('52b42edf', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=52b42edf&scoped=true&", function () {
      api.rerender('52b42edf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N6jo8SCr4F4R/JS/comp/DocBox.vue"
export default component.exports